'use client';

import { ISalePageDetailResponse } from '@/api/types';
import { Tag } from '@/components';
import { Row, Skeleton } from '@vuddy/components';
import { isNil } from 'lodash-es';
import { SalePageStatusTag } from '../statusTag';
import { SalePageTypeTag } from '../typeTag';

interface SalePageTagsProps {
  salePage?: Partial<ISalePageDetailResponse>;
}

export const SalePageTags = ({ salePage }: SalePageTagsProps) => {
  return (
    <Row gap="gap_xs">
      {isNil(salePage) ? (
        <>
          <Skeleton width="80px" />
          <Skeleton width="80px" />
          <Skeleton width="80px" />
        </>
      ) : (
        <>
          {salePage.type !== 'CLASS' && (
            <SalePageTypeTag type={salePage.type} />
          )}
          {salePage.hasCustomMediaProducts && (
            <Tag label="커스텀" variant="blue" size="small" />
          )}
          {salePage.physical?.method === 'RESERVATION' && (
            <Tag label="예약판매" variant="lightblue" size="small" />
          )}
          <SalePageStatusTag
            saleStatus={salePage.saleStatus}
            startAt={salePage?.saleTimeRange?.startAt}
          />
        </>
      )}
    </Row>
  );
};
